import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
  state: () => ({
    phone: null,
    authToken: null,
    user: null
  }),
  actions: {
    setPhone(newPhone) {
      this.phone = newPhone
    },
    setToken(token) {
      this.authToken = token
    },
    setUser(userObj) {
      this.user = userObj;
    },
    logout() {
      this.phone = null
      this.authToken = null
      this.user = null
      localStorage.removeItem('authToken')
      localStorage.removeItem('user')
      localStorage.removeItem('phone')
    },
  },
})
